import { render, staticRenderFns } from "./CustomerModulesButton.vue?vue&type=template&id=ac73bf12&"
import script from "./CustomerModulesButton.vue?vue&type=script&lang=js&"
export * from "./CustomerModulesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports